import type { InputHTMLAttributes, PropsWithChildren } from 'react';

import { Timecode } from '@iconik-io/core/src/timecode';

import { zeroTimecode } from '../../../../../../utils/constants/timecode';
import type { TimecodeOptions } from '../../../../../../utils/get_proxy_timecode_options';

type Props = PropsWithChildren<
  InputHTMLAttributes<HTMLInputElement> & {
    timecodeOptions: TimecodeOptions;
  }
>;

export function TimecodeField({ timecodeOptions, ...props }: Props) {
  const startTimecodeObject = new Timecode(timecodeOptions, {
    smpte: timecodeOptions.startTimecode ?? zeroTimecode,
  });
  const valueSeconds = props.value ? Number(props.value) / 1000 : 0;
  const startTime = startTimecodeObject.toSeconds();
  const secondsOffset = valueSeconds + startTime;

  const timecode = new Timecode(timecodeOptions, {
    seconds: secondsOffset,
  });

  return timecode.toSMPTE();
}
